const pageDetail = () => import(/* webpackChunkName: "project-project" */ './list/pageDetail');

export default [
    {
        path: '/pageMana/pageDetail',
        name: 'pageDetail',
        component: pageDetail,
        meta: {
            guide: [
                {
                    path: '/pageMana/pageDetail',
                    title: '网页管理',
                },
                {
                    path: '/pageMana/1',
                    title: '站点管理',
                },
            ],
            access: {
                actionsCode: ['04201001'],
                includeOrg: [],
                outsideOrg: [],
            },
        },
    },
];
